import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { DeliveryFence, DeliveryFenceCore, DeliveryFenceRequest } from '../types/fence';
import { deleteRequest, downloadRequest, getRequest, postRequest } from './api';
import { deliveryFenceUrl, deliveryFencesFileUrl, deliveryFencesUrl } from './urls/fenceUrls';

export const getDeliveryFences = async (
  clientId: string,
  subClientId: string,
  page: number = 1,
  search: string = ''
): Promise<{ paginatedResponse?: PaginatedResponse<DeliveryFenceCore>; error?: ApiError }> => {
  const response = await getRequest(deliveryFencesUrl, { queryParams: { clientId, subClientId, page, search } });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const getDeliveryFence = async (
  deliveryFenceId: string,
  clientId: string,
  subClientId: string
): Promise<{ deliveryFence?: DeliveryFence; error?: ApiError }> => {
  const response = await getRequest(deliveryFenceUrl(deliveryFenceId), { queryParams: { clientId, subClientId } });
  return {
    deliveryFence: response?.data,
    error: response?.error,
  };
};

export const deleteDeliveryFence = async (
  clientId: string,
  subClientId: string,
  deliveryFenceId: string
): Promise<{ error?: ApiError }> => {
  const response = await deleteRequest(deliveryFenceUrl(deliveryFenceId), { queryParams: { clientId, subClientId } });

  return {
    error: response?.error,
  };
};

export const updateDeliveryFence = async (data: DeliveryFenceRequest): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(deliveryFenceUrl(data._id), {
    body: data,
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const postDeliveryFence = async (data: DeliveryFenceRequest): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(deliveryFencesUrl, {
    body: data,
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const getDeliveryFencesFileKey = async (
  clientId: string,
  subClientId: string
): Promise<{ key?: string; error?: ApiError }> => {
  const response = await getRequest(deliveryFencesFileUrl, { queryParams: { clientId, subClientId } }, 'text');

  return {
    key: response?.data,
    error: response?.error,
  };
};

export const getDeliveryFencesFile = async (key: string): Promise<{ file?: Blob; error?: ApiError }> => {
  const response = await downloadRequest(`public/${key}`);

  return {
    file: response?.data?.file,
    error: response?.error,
  };
};
